import { createStore } from "vuex";
import service from "@/axios/index.js";
import { setStorage } from "@/utils/index.js";

export default createStore({
  state: {
    webImgurl: "",
    sliderInfo: {},
    reportUrl: "", // 上报地址
    timeStampError:0, 
  },
  getters: {},
  mutations: {
    set_webImgurl(state, url) {
      state.webImgurl = url;
      console.log(state.webImgurl);
    },
    SET_SLIDER_INFO: (state, value) => {
      console.log("///////////////////////");
      state.sliderInfo = value;
    },
    SET_REPORT_URL: (state, v) => {
      state.reportUrl = v;
    },
    //设置时间戳
    setTimeStampError(state, data) {
      state.timeStampError = data;
      setStorage("timeStampError", data);
    },
  },
  actions: {
    getTimeStampFn: ({ commit }) => {
      return new Promise((resolve, reject) => {
        let d = new Date();
        let timeStamp = Math.trunc(
          parseInt(d.getTime() / 1000) + d.getTimezoneOffset() * 60
        );
        service({
          method: "POST",
          url: "/base/getTimeStamp",
          data: {},
        })
          .then((resData) => {
            let num = resData.data.data.timeStamp - timeStamp;
            commit("setTimeStampError", num);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
  modules: {},
});
